import { computed, onMounted, onUnmounted, ref } from 'vue'

import type { Ref } from 'vue'

const formattedLastChange = (date: Date) => {
  const day = date.getDate().toString().padStart(2, '0')
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const year = date.getFullYear()
  const hours = date.getHours().toString().padStart(2, '0')
  const minutes = date.getMinutes().toString().padStart(2, '0')
  const seconds = date.getSeconds().toString().padStart(2, '0')

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`
}

export const useVisibility = (): {
  isVisible: Ref<boolean>
  lastVisibilityChange: Ref<string>
} => {
  const isVisible = ref(document.visibilityState === 'visible')
  const dateChange = ref(new Date())
  const lastVisibilityChange = computed(() => formattedLastChange(dateChange.value))

  const handleVisibilityChange = () => {
    isVisible.value = document.visibilityState === 'visible'
    dateChange.value = new Date()
  }

  onMounted(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange)
  })

  onUnmounted(() => {
    document.removeEventListener('visibilitychange', handleVisibilityChange)
  })

  return {
    isVisible,
    lastVisibilityChange,
  }
}
